import React, { FC } from 'react';
import { EmailTemplate } from '../types/emailTemplates';
import { useTranslation } from 'react-i18next';
import { getCategoryBadgeStyle } from './config';

type EmailTemplateTableProps = {
  items: EmailTemplate[];
  onEdit: (templateId: string) => void;
  onRequestDelete: (template: EmailTemplate) => void;
};

export const EmailTemplateTable: FC<EmailTemplateTableProps> = ({ items }) => {
  const { t } = useTranslation('campaign');
  return (
    <table className='min-w-full divide-y divide-gray-200'>
      <thead className='bg-gray-50'>
        <tr>
          <th className='px-4 py-3 text-left text-xs font-semibold uppercase tracking-[0.16em] text-quaternary-500'>{t('whatsappTemplates.tableName')}</th>
          <th className='px-4 py-3 text-left text-xs font-semibold uppercase tracking-[0.16em] text-quaternary-500'>
            {t('emailWorkspace.templates.tableCategory')}
          </th>
          <th className='px-4 py-3 text-left text-xs font-semibold uppercase tracking-[0.16em] text-quaternary-500'>
            {t('emailWorkspace.templates.subjectLabel')}
          </th>
          <th className='px-4 py-3 text-left text-xs font-semibold uppercase tracking-[0.16em] text-quaternary-500'>
            {t('whatsappTemplates.tableLastUpdated')}
          </th>
        </tr>
      </thead>
      <tbody className='divide-y divide-gray-200 bg-white'>
        {items?.map((item) => (
          <tr key={item.id} className='hover:bg-gray-50'>
            <td className='px-4 py-4'>
              <p className='text-sm font-semibold text-slate-900'>{item.name}</p>
            </td>
            <td className='px-4 py-4'>
              <span
                className={`inline-flex rounded-full px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.14em] ${getCategoryBadgeStyle(item.category)}`}
              >
                {item.category}
              </span>
            </td>
            <td className='px-4 py-4'>
              <p className='line-clamp-2 max-w-xs text-sm text-secondary-600'>{item.subject}</p>
            </td>
            <td className='px-4 py-4 text-sm text-secondary-600'>{item.updatedAtLabel}</td>
            {/* <td className='px-4 py-4'>
              <ActionButton onEdit={() => onEdit(item.id)} onDelete={() => onRequestDelete(item)} />
            </td> */}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
